import { pause_video } from './helpers';
import infoHotspotIcon from 'url:../assets/PC-white-nobg.png';
import xIcon from 'url:../SVG/close-line.svg';
import rightChev from 'url:../SVG/chevron-right.svg';
import leftChev from 'url:../SVG/chevron-left.svg';

export function createInfoHotspotElement(hotspot) {
  var wrapper = document.createElement('div');
  wrapper.classList.add('hotspot');
  wrapper.classList.add('info-hotspot');

  // Create hotspot/tooltip header.
  var header = document.createElement('div');
  header.classList.add('info-hotspot-header');
  hotspot.class && header.classList.add(hotspot.class);

  // Create image element.
  var iconWrapper = document.createElement('div');
  iconWrapper.classList.add('info-hotspot-icon-wrapper');
  var icon = document.createElement('img');
  icon.src = `${infoHotspotIcon}`;
  icon.classList.add('info-hotspot-icon');
  iconWrapper.appendChild(icon);

  // Create title element.
  const titleWrapper = document.createElement('div');
  titleWrapper.classList.add('info-hotspot-title-wrapper');
  const title = document.createElement('div');
  title.classList.add('info-hotspot-title');
  title.innerHTML = hotspot.title;
  titleWrapper.appendChild(title);

  // Create close element.
  var closeWrapper = document.createElement('div');
  closeWrapper.classList.add('info-hotspot-close-wrapper');
  var closeIcon = document.createElement('img');
  closeIcon.src = `${xIcon}`;
  closeIcon.classList.add('info-hotspot-close-icon');
  closeWrapper.appendChild(closeIcon);

  // Construct header element.
  header.appendChild(iconWrapper);
  header.appendChild(titleWrapper);
  header.appendChild(closeWrapper);

  header.appendChild(iconWrapper);
  header.appendChild(titleWrapper);
  header.appendChild(closeWrapper);

  // Create content element.
  const content = document.createElement('div');
  content.classList.add('info-hotspot-content');

  //text element
  const textContent = document.createElement('div');
  textContent.classList.add('product-txt-container');
  const textWrapper = document.createElement('div');
  textWrapper.classList.add('product-txt-wrapper');
  const subhead = document.createElement('h2');
  subhead.classList.add('product-txt-subhead');
  hotspot.subhead
    ? (subhead.innerHTML = hotspot.subhead)
    : (subhead.innerHTML = hotspot.title);
  const text = document.createElement('div');
  text.innerHTML = hotspot.text;
  text.classList.add('product-txt');

  const recipes = document.createElement('div');
  recipes.classList.add('recipes');
  const recipesHeader = document.createElement('h2');
  recipesHeader.classList.add('recipes-header');
  recipesHeader.textContent = 'Recipes to Try:';
  recipes.appendChild(recipesHeader);
  const recipesList = document.createElement('div');
  recipesList.classList.add('recipes-list');

  hotspot.recipes &&
    hotspot.recipes.map((_recipe, i) => {
      const recipe_title = document.createElement('p');
      const recipe_el = document.createElement('li');
      const recipe_link = document.createElement('a');
      const recipeImage = document.createElement('img');

      const recipeObj = hotspot.recipes[i].img;

      recipe_title.classList.add('recipe-title');
      recipe_title.innerHTML = hotspot.recipes[i].id;
      recipe_title.href = hotspot.recipes[i].link;
      recipe_title.setAttribute('target', '_blank');

      recipe_link.classList.add('recipe-link');
      recipe_link.href = hotspot.recipes[i].link;
      recipe_link.setAttribute('target', '_blank');
      recipe_link.setAttribute('rel', 'noreferrer');
      recipeImage.setAttribute('src', `${recipeObj.src}`);
      recipeImage.setAttribute('width', '200');
      recipeImage.setAttribute('height', '200');
      recipeImage.classList.add('recipe-preview-img-wrap');
      recipeImage.setAttribute('loading', 'lazy');
      recipeImage.style.display = 'block';

      recipe_link.appendChild(recipeImage);
      recipe_link.appendChild(recipe_title);
      recipe_el.appendChild(recipe_link);
      recipesList.appendChild(recipe_el);
    });

  if (!hotspot.recipes) {
    recipes.style.display = 'none';
    recipesHeader.innerHTML = '';
  }
  recipes.appendChild(recipesList);

  textWrapper.appendChild(subhead);
  textWrapper.appendChild(text);
  textWrapper.appendChild(recipes);

  textContent.appendChild(textWrapper);

  //carousel
  const carousel_container = document.createElement('div');
  carousel_container.classList.add('carousel_container');

  const carousel = document.createElement('div');
  carousel.classList.add('carousel');

  const carouselImages = document.createElement('div');
  carouselImages.classList.add('carousel-images');

  const carouselNav = document.createElement('div');
  carouselNav.classList.add('carousel-nav');

  const carouselNext = document.createElement('img');
  carouselNext.src = `${rightChev}`;
  carouselNext.classList.add('carousel-button');
  carouselNext.classList.add('next');
  carouselNext.setAttribute('id', 'next');
  const carouselPrev = document.createElement('img');
  carouselPrev.src = `${leftChev}`;
  carouselPrev.classList.add('carousel-button');
  carouselPrev.classList.add('previous');
  carouselPrev.setAttribute('id', 'previous');
  const carousel_pagination = document.createElement('ul');
  carousel_pagination.classList.add('carousel-pagination');

  hotspot.images &&
    hotspot.images.map((_image, i) => {
      const carousel_bullet = document.createElement('li');
      carousel_bullet.classList.add('carousel-bullet');
      const productImage = document.createElement('div');
      const productImageSrc = document.createElement('img');
      productImage.setAttribute('id', 'product-image');
      productImageSrc.src = `https://pamperedchef.widen.net/content/${hotspot.images[i].id}/jpeg/${hotspot.images[i].key}.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80`;
      productImage.appendChild(productImageSrc);
      carouselImages.appendChild(productImage);
      carousel_pagination.appendChild(carousel_bullet);
      carousel_container.appendChild(carousel_pagination);
      hotspot.images[i].contain === 'contain' &&
        productImageSrc.classList.add('contain');
    });

  hotspot.videos &&
    hotspot.videos.map((_video, i) => {
      const carousel_bullet = document.createElement('li');
      carousel_bullet.classList.add('carousel-bullet');
      const video = document.createElement('div');
      video.innerHTML = hotspot.videos[i];
      video.classList.add('iframe_container__video');

      carousel_pagination.appendChild(carousel_bullet);

      carouselImages.append(video);
    });

  carousel.appendChild(carouselImages);
  carouselNav.appendChild(carouselNext);
  carouselNav.appendChild(carouselPrev);
  carousel_container.appendChild(carouselNav);

  carousel_container.appendChild(carousel);

  content.appendChild(textContent);
  content.appendChild(carousel_container);

  wrapper.appendChild(header);
  wrapper.appendChild(content);

  const modal = document.createElement('div');
  modal.classList.add('info-hotspot-modal');

  modal.innerHTML = wrapper.innerHTML;

  function reset_modal() {
    setTimeout(() => {
      document.querySelector('.product-txt-container').scrollTo(0, 0);
      slideTo(0);
    }, 500);
    pause_video();
  }

  const openModal = function () {
    if (document.body.classList.contains('tour-init')) {
      hotspot.class ? modal.classList.add(hotspot.class) : '';
    } else {
      modal.classList.remove(hotspot.class);
    }
    document.body.appendChild(modal);
    reset_modal();
    setTimeout(() => {
      modal.classList.add('visible');
    }, 100);
  };

  const closeModal = function () {
    modal.classList.remove('visible');
    reset_modal();
    setTimeout(() => {
      modal.remove();
    }, 500);
  };

  wrapper
    .querySelector('.info-hotspot-header')
    .addEventListener('click', openModal);

  modal
    .querySelector('.info-hotspot-close-wrapper')
    .addEventListener('click', closeModal);

  modal.addEventListener('mouseover', function (e) {
    if (e.target === modal && modal.classList.contains('visible')) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal && modal.classList.contains('visible')) {
          modal.classList.remove('visible');
          reset_modal();
        }
      });
    }
  });

  const nextBtn = modal.querySelector('#next');
  const prevBtn = modal.querySelector('#previous');

  const carouselImgs = modal.querySelector('.carousel-images');
  const numberOfImages = modal.querySelectorAll('.carousel-images > *').length;
  const pagination = modal.querySelector('.carousel-pagination');
  const bullets = [].slice.call(modal.querySelectorAll('.carousel-bullet'));

  let currentIndex = 0;
  let percentage = 100;

  let touchstartX = 0;
  let touchendX = 0;

  function handleGesture() {
    if (touchendX < touchstartX && currentIndex !== numberOfImages - 1) {
      nextBtn.click();
    }
    if (touchendX > touchstartX && currentIndex !== 0) {
      prevBtn.click();
    }
  }

  document.body.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape') {
      closeModal();
    }
  });

  carouselImgs.addEventListener('touchstart', (e) => {
    touchstartX = e.changedTouches[0].pageX;
  });

  carouselImgs.addEventListener('touchend', (e) => {
    touchendX = e.changedTouches[0].pageX;
    handleGesture();
  });

  carouselImgs.addEventListener('mousedown', (e) => {
    touchstartX = e.pageX;
  });

  carouselImgs.addEventListener('mouseup', (e) => {
    touchendX = e.pageX;
    handleGesture();
  });

  // carouselImgs.addEventListener(
  //   "wheel",
  //   (e) => {
  //     let wheel_direction = e.deltaY * 1;
  //     if (Math.sign(wheel_direction) === -1) {
  //       if (currentIndex !== 0) prevBtn.click();
  //     } else {
  //       if (currentIndex !== numberOfImages - 1) nextBtn.click();
  //     }
  //   },
  //   { passive: true }
  // );

  function next() {
    slideTo(currentIndex + 1);
  }

  function prev() {
    slideTo(currentIndex - 1);
  }

  function slideTo(index) {
    index =
      index < 0 ? numberOfImages - 1 : index >= numberOfImages ? 0 : index;
    carouselImgs.style.WebkitTransform = carouselImgs.style.transform =
      'translate(-' + index * percentage + '%, 0)';
    bullets[currentIndex].classList.remove('active-bullet');
    bullets[index].classList.add('active-bullet');
    currentIndex = index;
  }

  hotspot.images && bullets[currentIndex].classList.add('active-bullet');
  prevBtn.addEventListener('click', prev, false);
  nextBtn.addEventListener('click', next, false);

  pagination &&
    pagination.addEventListener(
      'click',
      function (e) {
        let index = bullets.indexOf(e.target);
        if (index !== -1 && index !== currentIndex) {
          slideTo(index);
        }
      },
      false
    );

  if (!hotspot.images) {
    const modalContainer = modal;
    modalContainer.classList.add('fullWidth');
    const modal_content = modal.querySelector('div.info-hotspot-content');
    modal_content.classList.add('fullwidth_modal');
    removeAllChildNodes(modal_content);
    const iframe_container = document.createElement('div');
    iframe_container.classList.add('iframe_container');
    iframe_container.innerHTML = hotspot.text;
    modal_content.appendChild(iframe_container);
  }

  function removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  return wrapper;
}

// Create text element.
//
// var text = document.createElement("div");
// text.classList.add("info-hotspot-text");
// text.innerHTML = hotspot.text;

// // Place header and text into wrapper element.
// wrapper.appendChild(header);
// wrapper.appendChild(text);

// // Create a modal for the hotspot content to appear on mobile mode.
// var modal = document.createElement("div");
// modal.innerHTML = wrapper.innerHTML;
// modal.classList.add("info-hotspot-modal");
// document.body.appendChild(modal);

// var toggle = function () {
//   wrapper.classList.toggle("visible");
//   modal.classList.toggle("visible");
// };

// // Show content when hotspot is clicked.
// wrapper
//   .querySelector(".info-hotspot-header")
//   .addEventListener("click", toggle);

// // Hide content when close icon is clicked.
// modal
//   .querySelector(".info-hotspot-close-wrapper")
//   .addEventListener("click", toggle);

// // Prevent touch and scroll events from reaching the parent element.
// // This prevents the view control logic from interfering with the hotspot.
// // stopTouchAndScrollEventPropagation(wrapper);

// return wrapper;
// }
